import React from 'react';
import { FaHeart, FaShareAlt, FaStar } from 'react-icons/fa';
import img1 from '../../assets/images/pr1.webp';
import img2 from '../../assets/images/pr2.webp';
import img3 from '../../assets/images/pr3.webp';
import img4 from '../../assets/images/lady10.jpeg';

const products = [
  {
    id: 1,
    name: "Basic Colored Sweatpants With Elastic Hems",
    image: img1,
    reviews: 2,
    oldPrice: 25.90,
    newPrice: 19.90,
    discount: 24,
    colors: ["#f00", "#0ff", "#f0f", "#ff0", "#000", "#0f0", "#00f"],
  },
  {
    id: 2,
    name: "Ribbed V-Neck Cardigan With Rhinestone Detail",
    image: img2,
    reviews: 1,
    oldPrice: null,
    newPrice: 28.00,
    discount: null,
    colors: ["#f00", "#0ff", "#f0f", "#ff0", "#000", "#0f0", "#00f"],
  },
  {
    id: 3,
    name: "Brown Mountain Graphic Sweatshirt",
    image: img3,
    reviews: 1,
    oldPrice: 261.83,
    newPrice: 22.60,
    discount: null,
    colors: ["#f00", "#0ff", "#f0f", "#ff0", "#000", "#0f0", "#00f"],
  },
  {
    id: 4,
    name: "Blue Starter Logo Tshirt",
    image: img4,
    reviews: 1,
    oldPrice: 22.70,
    newPrice: 18.70,
    discount: 18,
    countdown: "75d : 14h : 21m : 38s",
    colors: ["#f00", "#0ff", "#f0f", "#ff0", "#000", "#0f0", "#00f"],
  },
];

const RecentlyViewed = () => {
  return (
    <div className="px-4 py-8">
      <h2 className="text-xl sm:text-2xl font-semibold mb-5">Recently Viewed Products</h2>
      <hr className="border-gray-300 mb-6" />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map((product) => (
          <div
            key={product.id}
            className="bg-white border border-gray-100 shadow-md  overflow-hidden relative"
          >
            {product.discount && (
              <div className="absolute top-2 left-2 bg-green-100 text-green-700 font-bold text-xs px-2 py-1 ">
                {product.discount}%
              </div>
            )}

            <div className="absolute top-2 right-2 flex flex-col gap-2 text-gray-700 text-base">
              <FaHeart className="cursor-pointer hover:text-red-500" />
              <FaShareAlt className="cursor-pointer hover:text-blue-500" />
            </div>

            <img
              src={product.image}
              alt={product.name}
              className="w-full h-64 object-cover"
            />

            <div className="p-4">
              <p className="text-xs text-yellow-500 flex items-center gap-1 mb-1">
                <FaStar /> {product.reviews} review{product.reviews > 1 ? 's' : ''}
              </p>
              <h4 className="text-sm font-medium mb-2 line-clamp-2">{product.name}</h4>
              <p className="text-sm mb-2">
                {product.oldPrice && (
                  <span className="line-through text-gray-400 mr-2">
                    ${product.oldPrice.toFixed(2)}
                  </span>
                )}
                <span className="font-semibold">${product.newPrice.toFixed(2)}</span>
              </p>
              {product.countdown && (
                <p className="text-xs text-gray-600 font-bold mb-2">{product.countdown}</p>
              )}
              <div className="flex gap-2 mt-2">
                {product.colors.map((color, i) => (
                  <span
                    key={i}
                    className="w-4 h-4 rounded-full border border-gray-300"
                    style={{ backgroundColor: color }}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewed;
